<!-- <div class="p-2">
           <div class="d-flex">
            <button data-testid="auto-app-ai-sourcing-profile-slider-button-1" class="btn-trms-regular" style="width: 50%;" (click)="scrollTOCompareCompany(companyDetails)">
             <i class="fa-regular fa-user-minus mr-1"></i> Archive
            </button>
            <button data-testid="auto-app-ai-sourcing-profile-slider-button-2"  class="ml-2 btn-trms-small px-0" style="width: 50%;" (click)="redirecttoCompanylist(companyDetails)">
              <i class="fa-regular fa-user-plus mr-1"></i>Shortlist
            </button>
                 <button data-testid="auto-app-ai-sourcing-profile-slider-button-3"  class="ml-2 btn-trms-regular px-0" style="width: 50%;" (click)="redirecttoCompanylist(companyDetails)">
             <i class="fa-solid fa-envelopes-bulk"></i>Add to Email Campaign
            </button>
          </div>
</div> -->
